import React, { useState } from 'react';
import Modal from '../../constants/Modal';
import { useAddExerciseAttachment } from '../../services/exercisesAttachments/ExercisesAttachmentsService';
import Spinner from '../../common/Spinner';

interface ExercisesAttachmentsAddForDictExerciseProps {
  dictExerciseId: string;
}

const ExercisesAttachmentsAddForDictExercise: React.FC<ExercisesAttachmentsAddForDictExerciseProps> = ({ dictExerciseId }) => {
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const mutation = useAddExerciseAttachment();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  const handleSubmit = () => {
    if (file) {
      mutation.mutate({ file, dictExerciseId });
      setShowModal(false);
      setFile(null);
    }
  };

  return (
    <div>
      <button onClick={() => setShowModal(true)}>Add Attachment</button>

      <Modal show={showModal} onClose={() => setShowModal(false)} title="Upload Attachment">
        <div>
          <input type="file" onChange={handleFileChange} />
          <button onClick={handleSubmit} disabled={mutation.status === 'pending'}>
            {mutation.status === 'pending' ? <Spinner/> : 'Upload'}
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ExercisesAttachmentsAddForDictExercise;